import { html } from "lit";

export const NewsBlockTemplate = () => html`
    <div class="ux-iws-teaser-news-grid">
        <div class="ux-iws-teaser-news-grid__teaser-container">
            <ux-iws-link-wrapper class="ux-iws-teaser-news">
                <div class="ux-iws-teaser-news__content">
                    <span
                        class="ux-iws-teaser-news__info ux-text-small ux-text-small--bold"
                    >
                        news - 12/04/2021
                    </span>
                    <ux-text-lines-limit
                        text-lines-s="5"
                        text-lines-m="3"
                        text-lines-l="4"
                        text-lines-xl="3"
                    >
                        <p
                            class="ux-iws-teaser-news__news-content ux-text-normal ux-text-normal--light-gray"
                        >
                            <span
                                class="ux-iws-teaser-news__news-title ux-u-text-bold"
                            >
                                Wir sind für sie da!
                            </span>
                            <span class="ux-iws-teaser-news__news-body">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum
                                dolore eu fugiat nulla pariatur. Excepteur sint
                                occaecat cupidatat non proident, sunt in culpa
                                qui officia deserunt mollit anim id est laborum
                            </span>
                        </p>
                    </ux-text-lines-limit>
                </div>
                <div class="ux-iws-teaser-news__cta-container">
                    <a
                        href="#"
                        class="ux-button ux-button--icon-only"
                        title="next"
                        aria-label="next"
                        role="button"
                    >
                        <ux-icon name="chevron-right" />
                    </a>
                </div>
            </ux-iws-link-wrapper>
            <ux-iws-link-wrapper class="ux-iws-teaser-news">
                <div class="ux-iws-teaser-news__content">
                    <span
                        class="ux-iws-teaser-news__info ux-text-small ux-text-small--bold"
                    >
                        news - 12/04/2021
                    </span>
                    <ux-text-lines-limit
                        text-lines-s="5"
                        text-lines-m="3"
                        text-lines-l="4"
                        text-lines-xl="3"
                    >
                        <p
                            class="ux-iws-teaser-news__news-content ux-text-normal ux-text-normal--light-gray"
                        >
                            <span
                                class="ux-iws-teaser-news__news-title ux-u-text-bold"
                            >
                                Wir sind für sie da!
                            </span>
                            <span class="ux-iws-teaser-news__news-body">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum
                                dolore eu fugiat nulla pariatur. Excepteur sint
                                occaecat cupidatat non proident, sunt in culpa
                                qui officia deserunt mollit anim id est laborum
                            </span>
                        </p>
                    </ux-text-lines-limit>
                </div>
                <div class="ux-iws-teaser-news__cta-container">
                    <a
                        href="#"
                        class="ux-button ux-button--icon-only"
                        title="next"
                        aria-label="next"
                        role="button"
                    >
                        <ux-icon name="chevron-right" />
                    </a>
                </div>
            </ux-iws-link-wrapper>
            <ux-iws-link-wrapper
                class="ux-iws-teaser-news ux-iws-teaser-news--info-news"
            >
                <div class="ux-iws-teaser-news__icon-container">
                    <ux-icon name="info-rounded"></ux-icon>
                </div>
                <div class="ux-iws-teaser-news__content">
                    <p
                        class="ux-iws-teaser-news__news-content ux-text-normal ux-text-normal--light-gray"
                    >
                        <span class="ux-iws-teaser-news__news-title">
                            The title of ne news block
                        </span>
                        <span class="ux-iws-teaser-news__news-body">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris nisi ut aliquip
                            ex ea commodo consequat. Duis aute irure dolor in
                            reprehenderit in voluptate velit esse cillum dolore
                            eu fugiat nulla pariatur.
                        </span>
                    </p>
                </div>
                <div class="ux-iws-teaser-news__cta-container">
                    <a
                        href="#"
                        class="ux-button ux-button--icon-only"
                        title="next"
                        aria-label="next"
                        role="button"
                    >
                        <ux-icon name="chevron-right" />
                    </a>
                </div>
            </ux-iws-link-wrapper>
        </div>
        <a href="#" class="ux-button ux-iws-teaser-news-grid__cta">
            Archiv <ux-icon name="tiles"></ux-icon>
        </a>
    </div>
`;
